import { render, staticRenderFns } from "./toll-free-search.vue?vue&type=template&id=1f016f2f"
import script from "./toll-free-search.vue?vue&type=script&lang=js"
export * from "./toll-free-search.vue?vue&type=script&lang=js"
import style0 from "./toll-free-search.vue?vue&type=style&index=0&id=1f016f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports